import { createRequestTypes } from "../../utils";


// FETCH MUSHROOMS BY COUNTRY
export const FETCH_MUSHROOM_BY_COUNTRY = createRequestTypes("FETCH_MUSHROOM_BY_COUNTRY");


export const fetchMushroomByCountryRequest = (payload) =>
    ({ type: FETCH_MUSHROOM_BY_COUNTRY.REQUEST, payload });
export const fetchMushroomByCountrySuccess = (payload) =>
    ({ type: FETCH_MUSHROOM_BY_COUNTRY.SUCCESS, payload });
export const fetchMushroomByCountryFailure = (error) =>
    ({ type: FETCH_MUSHROOM_BY_COUNTRY.FAILURE, payload: { error } });
